<template>
  <form
    @submit.prevent="submit"
    style="position: relative;">
    <vue-particles
      v-if="loading"
      style="width: 100%; height: 100%; position: absolute; z-index: 2"
      color="#000000"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#212529"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="5"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push" />
    <div class="d-flex w-100 justify-content-between">
      <h5 class="mb-1">{{ $t('Create with AI') }}</h5>
    </div>
    <p class="mb-1">{{ $t('Use artificial intelligence to generate a scorecard template.') }}</p>
    <hr />
    <div :class="{'box-loading': loading}">
      <div class="alert alert-info">
        <p>Você pode gerar automaticamente um scorecard de entrevista com o apoio da IA, de forma rápida e personalizada.</p>
        <p>O Quickin usará os dados da vaga (como título, descrição, requisitos e comentários internos) para montar um scorecard completo com os critérios ideais de avaliação.</p>
        <p style="margin: 0;"><b>Dica:</b> Use o campo "Comentários Internos" da vaga para orientar a IA e tornar o scorecard ainda mais alinhado com suas necessidades.</p>
      </div>
      <div
        v-if="resourceAvailability.features.includes('voice_interview')"
        class="form-group">
        <label for="interviewType">{{ $t('Interview Type') }}</label>
        <div
          class="form-check"
          v-for="(item, index) in [{ value: 'conventional', label: $t('Conventional')}, {value: 'voice-interview', label: $t('Voice AI Interview')} ]"
          :key="index">
          <input
            class="form-check-input"
            type="radio"
            name="interviewType"
            :id="'interviewType' + index"
            :value="item.value"
            v-model="formData.interview_type">
          <label class="form-check-label" :for="'interviewType' + index">
            {{ item.label }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors['interview_duration']" />
      </div>
      <div class="form-group mt-3">
        <label>{{ $t('Interview Objective(s)') }}</label>
        <div
          class="form-check"
          v-for="(item, index) in interviewTypes"
          :key="index">
          <input
            class="form-check-input"
            type="checkbox"
            name="interviewTypes"
            :id="'interviewTypes' + index"
            :value="item.value"
            v-model="formData.interview_types">
          <label class="form-check-label" :for="'interviewTypes' + index">
            {{ item.label }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors['interview_types']" />
      </div>
      <div class="form-group">
        <label for="interviewDuration">{{ $t('Interview Duration') }}</label>
        <div
          class="form-check"
          v-for="(item, index) in interviewDurations"
          :key="index">
          <input
            class="form-check-input"
            type="radio"
            name="interviewDuration"
            :id="'interviewDuration' + index"
            :value="item.value"
            v-model="formData.interview_duration">
          <label class="form-check-label" :for="'interviewDuration' + index">
            {{ item.label }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors['interview_duration']" />
      </div>
      <div>
        <button
          type="submit"
          class="btn btn-primary">{{ $t('Generate scorecard') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="back">{{ $t('To go back') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'JobProfileScoreformsOptionsIA',
  components: {
  },
  props: {
    jobId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      validateErrors: {},
      interviewTypes: [
        { value: 'soft_skills', label: this.$t('Behavioral Competencies (e.g., organization, leadership...)') },
        { value: 'hard_skills', label: this.$t('Technical Knowledge') },
        { value: 'motivation_and_goals', label: this.$t('Motivation and Goals (why this position? what are they expecting from it?)') },
        { value: 'basic_requirements', label: this.$t('Basic Requirements (experience, education, etc.)') },
        { value: 'practical_information', label: this.$t('Practical Information (schedule, location, salary expectations, availability)') }
      ],
      interviewStages: [
        { value: 'screening', label: this.$t('Screening Interview (More objective)') },
        { value: 'selection', label: this.$t('Selection Interview (More in-depth)') }
      ],
      formData: {
        interview_types: [],
        interview_duration: null
      }
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    interviewDurations () {
      const items = [
        { value: '15_minutes', label: this.$t('15 minutes') },
        { value: '30_minutes', label: this.$t('30 minutes') },
        { value: '45_minutes', label: this.$t('45 minutes') },
        { value: '1_hour', label: this.$t('1 hour') },
        { value: '1_hour_30_minutes', label: this.$t('1 hour and 30 minutes') }
      ]

      if (this.formData.interview_type === 'voice-interview') {
        return items.slice(0, 2)
      }

      return items
    }
  },
  methods: {
    submit () {
      this.loading = true
      this.axios
      .post(`/accounts/${this.$store.getters.getAccount._id}/jobs/${this.jobId}/generate-scoreform`, this.formData)
      .then(response => {
        this.$emit('input', response.data)
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    back () {
      this.$emit('back')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobProfile/JobProfileScoreformsOptionsIA.vue